<template>
  <div class="graduates">
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <v-row class="graduates-filters">
          <v-col cols="12" md="auto">
            <the-professions-trigger
              v-model="showProfessionsList"
            ></the-professions-trigger>
          </v-col>
          <v-col cols="12" md="auto" class="flex-grow-0">
            <the-graduates-search-field></the-graduates-search-field>
          </v-col>
        </v-row>
        <the-professions-list
          v-model="showProfessionsList"
        ></the-professions-list>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            v-for="graduate in graduates.data"
            :key="graduate.id"
          >
            <graduate-card :graduate="graduate"></graduate-card>
          </v-col>
        </v-row>
        <div class="graduates-more">
          <button
            class="graduates-more-button"
            v-if="graduates.showMore"
            @click="showMore"
          >
            {{ $t('home.load_more') }}
          </button>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GraduateCard from '@/components/GraduateCard'
import TheGraduatesSearchField from '@/components/TheGraduatesSearchField'
import TheProfessionsList from '@/components/TheProfessionsList'
import TheProfessionsTrigger from '@/components/TheProfessionsTrigger'

export default {
  data() {
    return {
      showProfessionsList: false
    }
  },
  computed: {
    graduates() {
      return this.$store.getters['graduates/get']
    }
  },
  methods: {
    showMore() {
      this.$store.dispatch('graduates/increaseLimit')
    }
  },
  components: {
    GraduateCard,
    TheGraduatesSearchField,
    TheProfessionsList,
    TheProfessionsTrigger
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.graduates {
  position: relative;
  z-index: 1;
}

.graduates-filters {
  margin-bottom: 40px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    > div {
      padding-top: 6px;
      padding-bottom: 6px;
    }
  }
}

.graduates-more {
  margin: 80px 0 95px;
  text-align: center;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    margin: 40px 0 45px;
  }
}

.graduates-more-button {
  padding: 0 50px;
  border: 2px solid #000000;
  text-align: center;
  background: #fff;

  transition: background 0.2s;

  &:hover {
    background: #00f1b8;
  }
}
</style>
